import type { QuizSetDetailsRes } from '@/api/gen/_model/quizSetDetailsRes';
import { type CheckMyQuizStatus } from '@/hooks/useCheckMyQuiz';

import { type HeroCardData } from '../types';

export const useHeroCardData = (
  data: QuizSetDetailsRes,
  meStatus: CheckMyQuizStatus,
): HeroCardData => {
  return {
    image: {
      url: data.templateImageUrl || '',
      planType: data.templatePlanType,
      type: data.templateType,
    },
    category: data.categoryTreeData,
    title: data.title,
    author: data.authorUsername
      ? {
          username: data.authorUsername,
          id: data.authorId,
          isOfficial: data.isOfficial || false,
          avatarData: data.authorAvatarData,
        }
      : undefined,
    metadata: {
      createdAt: data.createdAt,
      playCount: data.playCount || 0,
      copyCount: data.copyCount || 0,
    },
    originalAuthor:
      data.originAuthorName && data.originAuthorId
        ? {
            name: data.originAuthorName,
            id: data.originAuthorId,
            isAmbassador: data.isOriginAuthorAmbassador || false,
          }
        : undefined,
    variant: meStatus === 'isMe' ? 'my' : 'default',
  };
};
